export const fonts = {
  base: "'Roboto', sans-serif",
  code: "'Roboto Mono', monospace",
};
